// converted using SVGR with React-Native and Typescript Options
// https://react-svgr.com/playground/?native=true&typescript=true
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { Icon } from './internal';

export const AudioWave: Icon = ({ color = '#000000', size = 24 }) => (
  <Svg width={size} height={size} fill="none" viewBox="0 0 2048 1063">
    <Path
      fill={color}
      d="m1176 292 9 1 7 6 2 4v457l-4 6-6 4h-11l-6-4-3-3-2-9V306l3-7 7-6zM554 300h12l7 6 3 8v435l-3 8-5 5-3 1h-10l-7-4-3-5-1-4V311l6-9z"
    />
    <Path fill={color} d="m1691 312 9 1 6 4 3 4 1 3v414l-3 7-5 4-2 1h-12l-6-4-4-8V324l3-6 6-5z" />
    <Path fill={color} d="M917 323h8l7 4 4 7 1 125v199l-1 71-4 7-5 3-9 1-7-3-5-6-1-3V334l4-7z" />
    <Path fill={color} d="M1329 348h8l6 3 5 6 1 3v342l-3 7-5 4-9 2-9-3-4-5-2-6V361l3-7 6-5z" />
    <Path
      fill={color}
      d="m506 353 8 1 5 3 4 6 1 3v331l-3 6-5 5-2 1h-11l-5-3-4-5-2-7V368l3-8 7-6z"
    />
    <Path fill={color} d="m608 373 10 1 7 6 2 4v295l-4 6-3 3-7 2-8-1-6-4-3-5-1-5V387l3-7 5-5z" />
    <Path fill={color} d="M1225 376h11l7 5 3 7v286l-3 7-6 5-3 1h-9l-6-4-5-8V388l3-6 6-5z" />
    <Path fill={color} d="M864 380h10l6 4 4 6 1 3v276l-4 9-5 4-8 1-9-3-5-7-1-4V393l4-8 5-4z" />
    <Path
      fill={color}
      d="M1845 380h7l6 3 5 6 1 2 1 125v47l-1 109-6 8-4 2h-12l-6-5-3-6V392l4-7 5-4z"
    />
    <Path
      fill={color}
      d="m1742 380 10 1 7 6 2 4v280l-4 7-3 3-3 1h-12l-6-5-3-6-1-7V398l2-9 6-7zM1431 388h10l7 4 4 7v265l-5 8-7 3h-8l-6-3-5-6-1-5V401l3-7 6-5z"
    />
    <Path fill={color} d="M350 385h7l6 3 6 7 1 190-1 81-5 8-5 3-7 1-9-4-4-5-1-2-1-262 1-9 4-6z" />
    <Path fill={color} d="M246 388h10l6 4 4 6v267l-6 8-5 2h-9l-6-3-4-5-1-2-1-42V403l3-9 6-5z" />
    <Path fill={color} d="m1124 391 9 1 6 4 3 4 1 4v251l-2 9-7 6-3 1h-10l-6-4-4-7V402l4-6 6-4z" />
    <Path fill={color} d="M966 399h12l5 3 4 5 1 3v243l-4 7-4 3-3 1h-10l-6-4-4-5-1-4V411l4-8z" />
    <Path fill={color} d="M760 402h12l6 4 4 8v234l-3 8-5 4-3 1h-11l-6-4-4-8V414l3-7 5-4z" />
    <Path fill={color} d="M143 406h9l7 4 4 7v228l-4 7-5 4-3 1h-7l-7-3-5-8-1-5V420l5-10z" />
    <Path
      fill={color}
      d="M1277 404h9l6 3 4 5 1 3 1 210-1 23-5 8-8 3-9-1-6-4-3-6-1-8V422l2-9 4-6z"
    />
    <Path fill={color} d="M659 416h8l6 3 5 6 1 3v206l-4 8-5 4-10 1-7-3-6-9V427l4-6 5-4z" />
    <Path fill={color} d="M453 416h8l6 3 4 5 1 2 1 14v182l-1 15-5 7-9 3-8-1-7-6-2-4V426l7-8z" />
    <Path fill={color} d="M1482 426h12l6 4 3 5 1 4v180l-1 9-7 8-3 1h-11l-6-4-4-7V436l4-6z" />
    <Path fill={color} d="M1636 428h12l7 4 3 6v187l-4 6-3 3-3 1h-12l-8-7-2-10V457l1-18 3-6z" />
    <Path fill={color} d="M298 430h9l6 4 3 3 2 6v177l-4 8-5 4-10 1-7-3-4-5-2-5V443l4-8 5-4z" />
    <Path
      fill={color}
      d="M1895 432h11l6 4 4 8v175l-5 9-6 3h-10l-6-4-4-6-1-4V445l4-8 5-4zM195 437h9l7 5 4 8v163l-3 6-6 6-3 1h-8l-6-4-6-8V449l4-7z"
    />
    <Path fill={color} d="M1019 437h10l6 4 4 6 1 4v156l-1 9-7 8-5 2h-7l-7-4-4-5-1-3V449l4-7z" />
    <Path fill={color} d="m1795 441 10 2 5 4 3 6v157l-5 8-7 3h-9l-5-3-5-6-1-3V453l5-8 5-3z" />
    <Path fill={color} d="M710 445h9l6 3 4 5 1 2v153l-6 8-6 2h-8l-6-3-4-5-1-2-1-49V459l3-8 6-5z" />
    <Path
      fill={color}
      d="m1382 449 9 1 6 4 3 5 1 104v18l-1 23-7 8-2 1h-12l-5-3-4-5-1-3V460l4-6 5-4zM401 461h9l5 3 4 5 2 4v117l-6 9-6 3h-7l-7-3-5-7-1-3V474l4-8 5-4z"
    />
    <Path fill={color} d="m1949 465 8 1 5 3 5 6 1 5v100l-1 8-6 7-8 3-7-1-7-5-3-6V476l6-8z" />
    <Path fill={color} d="M1534 467h10l6 3 4 5 1 3v107l-5 8-7 3h-8l-6-3-4-5-2-5V480l3-7 6-5z" />
    <Path fill={color} d="m815 468 9 1 5 3 4 6 1 88-1 19-7 8-9 2-9-3-5-6-2-9v-91l2-9 6-7z" />
    <Path fill={color} d="m93 474 9 1 6 4 3 5 1 4v87l-3 7-5 5-9 2-9-3-5-6-1-2v-93l4-6 3-3z" />
    <Path fill={color} d="M1070 478h11l6 4 3 4 1 3v85l-4 7-4 3-4 1h-8l-6-3-4-5-2-5v-66l1-17 4-7z" />
    <Path fill={color} d="M1587 485h7l7 3 4 5 2 6v64l-4 10-6 4-9 1-7-3-4-5-2-5v-68l5-8 4-3z" />
    <Path fill={color} d="M2000 496h11l5 3 4 5 1 2v50l-4 7-4 3-4 1h-9l-6-4-4-5-1-4v-42l2-8 5-6z" />
    <Path fill={color} d="M39 507h11l6 4 4 8v26l-4 7-7 4h-9l-6-3-4-5-2-7v-20l3-8 6-5z" />
    <Path
      fill={color}
      d="m1184 355 3 1-10 8-3 3-1 4-2-4 10-10zM609 412h3l6 8 4 3v3h-2l-7-8-4-4zM917 362l7 6 6 6-1 2-12-11zM295 469l4 1 7 6 2 3-1 3-8-9zM619 402l2 1 1 13-2 2-1-2zM305 458h1l1 11h6l2 2-2 1-7-1-1-1-1-10zM1430 627l4 2 4 4v2l3-1 1 3h-4l-8-9z"
    />
  </Svg>
);
